export default __webpack_public_path__ + "static/media/iconfinder_node_3069651.72af890a.svg";